/**
 * Product-detail hero image — same image everywhere, but supports a
 * mobile-only crop-position override (set via the admin's focal point
 * picker) without touching desktop at all. Desktop always uses
 * `desktopPosition` (each page's existing behavior); mobile uses
 * `mobilePosition` when set, otherwise falls back to `desktopPosition`.
 *
 * Pure CSS (custom properties + one media query in index.css) — no JS
 * viewport listener needed.
 */
export const HeroImage = ({ src, alt = "", className = "", desktopPosition = "center center", mobilePosition }) => (
  <img
    src={src}
    alt={alt}
    className={`hero-focal-img ${className}`}
    fetchpriority="high"
    style={{
      "--hero-pos-desktop": desktopPosition,
      "--hero-pos-mobile": mobilePosition || desktopPosition,
    }}
  />
);
